import { Grid } from "@mui/material";
import React from "react";
import WSSelectField from "../../Components/Select/WSSelect";
import { useForm } from "react-hook-form";
import config from "../../Config/clientConfig.json";
import WSTextField from "../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";

export const WriteMessage:React.FC<any>=React.memo((props)=>{
    const {register,control} = useForm()
    return(
        <Grid container spacing={2}>
            <Grid item xs={12}>
            <WSSelectField
                rules={{ required: true }}
                {...register("recipient")}
                id="recipient"
                control={control}
                defaultValue={"0"}
                label="To"
                name="recipient"
                labelType="Normal"
                options={config.recipientConfig.staticOptionData}
                />
            </Grid>
            <Grid item xs={12}>
            <WSTextField
            label={"Subject"}
            {...register("subject")}
            id="subject"
            name="subject"
            control={control}
            rules={{ required: false }}
            labelType="Normal"/>
            </Grid>
            <Grid item xs={12}>
            <WSTextAreaField
                  label={""}
                  id={"messagebody"}
                  name={"messagebody"}
                  control={control}
                  rules={{ required: false }}
                  rows={6}
                />         
            </Grid>
        </Grid>
    )
})